import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { LocationService } from '../../../services/location.service';
import { GoogleMaps } from '../../../classes/constants';

@Component({
  selector: 'app-location-card',
  templateUrl: './location-card.component.html',
  styleUrls: ['./location-card.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationCardComponent {
  // Signal-based inputs
  showLocation = input<boolean>();
  isOfflineCache = input<boolean>();
  chatMessage = input<any>();
  latitude = input<number>();
  longitude = input<number>();
  isMine = input<boolean>();

  // Signal-based output
  showLocationChange = output<boolean>();

  // Computed signal for Google Map ID
  googleMapId = computed(() => GoogleMaps.MAP_ID);

  // Computed signal for offset height
  offsetHeight = computed(() => {
    const message = this.chatMessage();
    if (message) {
      return message.offsetWidth / 1.5 / 14 + 'rem';
    } else {
      return '21.125rem';
    }
  });

  constructor(public locationService: LocationService) {}

  public showLocationMessage() {
    this.showLocationChange.emit(true);
  }
}
